const ee = window.ee; // @TODO Move on to @google/earthengine

export { ee };

export const authenticateViaOauth = async (
  clientId,
  scopes = null,
  onImmediateFailure = () => {}
) => {
  return await new Promise((resolve, reject) => {
    ee.data.authenticateViaOauth(
      clientId,
      (success) => resolve(success),
      (error) => reject(error),
      scopes,
      (immediate) => {
        try {
          onImmediateFailure();
          resolve();
        } catch (e) {
          reject(e);
        }
      }
    );
  });
};

export const load = async (baseUrl = null, tileUrl = null) => {
  window.ee = ee;
  return await new Promise((resolve, reject) => {
    ee.initialize(
      baseUrl,
      tileUrl,
      (success) => resolve(success),
      (error) => reject(error)
    );
  });
};

export const initializeEEConnection_backup = async (
  clientId = null,
  scopes = null,
  onImmediateFailure = () => {}
) => {
  await authenticateViaOauth(clientId, scopes, onImmediateFailure);
  await load();
  return ee.data.getAuthToken();
};

export const initializeEEConnection = async (token) => {
  if (!token) {
    throw new Error("Token is required for initializing Earth Engine.");
  }

  // Set the token for Earth Engine
  ee.data.setAuthToken(
    null, // Client name (null for backend-managed tokens)
    'Bearer',
    token, // Token passed from the backend
    3600 * 6, // Expiration time (match token's validity)
    [],
    () => {
      console.log("Earth Engine connection initialized successfully.");
    },
    (err) => {
      console.error("Failed to initialize Earth Engine connection:", err);
      throw new Error(err.message || "Earth Engine initialization failed.");
    }
  );
};


export default ee;
